import { z } from 'zod';
import { createMessage, NativeMessageSchema } from './NativeMessage';

export const SafeAreaSchema = z.object({
  top: z.number(),
  left: z.number(),
  right: z.number(),
  bottom: z.number(),
});

export type SafeArea = z.infer<typeof SafeAreaSchema>;

export const DeviceRoleSchema = z.union([z.literal('patient'), z.literal('team')]);
export type DeviceRole = z.infer<typeof DeviceRoleSchema>;

export const DevicePlatformSchema = z.union([z.literal('android'), z.literal('ios')]);
export type DevicePlatform = z.infer<typeof DevicePlatformSchema>;

export const SetupMessageSchema = z
  .object({
    type: z.literal('setup'),
    content: z.object({
      nativeAppVersion: z.string(),
      safeArea: SafeAreaSchema.partial(),
      biometricAuthentication: z.boolean().optional(),
      biometricsAvailable: z.union([z.literal('Face ID'), z.literal('Touch ID')]).optional(),
      clientTenant: z.string().optional(),
      clientRole: DeviceRoleSchema.optional(),
      clientPlatform: DevicePlatformSchema.optional(),
    }),
  })
  .extend(NativeMessageSchema.shape);

export type SetupMessage = z.infer<typeof SetupMessageSchema>;
export type BiometricType = Required<SetupMessage['content']>['biometricsAvailable'];

export const RequestSetupMessageSchema = z
  .object({
    type: z.literal('requestSetup'),
  })
  .extend(NativeMessageSchema.shape);

export type RequestSetupMessage = z.infer<typeof RequestSetupMessageSchema>;

export const createRequestSetupMessage = () =>
  ({
    ...createMessage(),
    type: 'requestSetup',
  }) satisfies RequestSetupMessage;
